import type { BonusTab, FirstDepositBonusResponse } from '../types/bonus';
import { BONUS_TAB, BonusStatus, CampaignProduct } from '../types/bonus';

export const getCampaignProductFromBonusPath = (pathname: string): CampaignProduct =>
  pathname.includes('/casino') ? CampaignProduct.CASINO : CampaignProduct.SPORTSBOOK;

export const isBonusExpired = (bonus: FirstDepositBonusResponse): boolean => {
  const pastExpiryDate = bonus.expiryDate ? new Date(bonus.expiryDate) < new Date() : false;

  return pastExpiryDate || bonus.status === BonusStatus.EXPIRED;
};

export const getBonusDisplayStatus = (bonus: FirstDepositBonusResponse): BonusTab => {
  const { status } = bonus;

  if (status === BonusStatus.COMPLETED) return BONUS_TAB.COMPLETED;
  if (status === BonusStatus.FAILED || status === BonusStatus.FORFEITED) return BONUS_TAB.FAILED;
  if (isBonusExpired(bonus)) return BONUS_TAB.EXPIRED;

  return BONUS_TAB.OPEN;
};

export const getProgress = (current: number | null, required: number | null): number => {
  if (!required || required <= 0 || current === null) return 0;

  return Math.min(100, (current / required) * 100);
};

export const formatBonusAmount = (
  amount: number | null | undefined,
  currency: string | null | undefined,
  language: string
): string => {
  if (amount === null || amount === undefined) {
    return '-';
  }

  if (!currency) {
    return `$${amount.toFixed(2)}`;
  }

  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const getFirstDepositBonusProgressPercent = (
  bonus: FirstDepositBonusResponse,
  productType: CampaignProduct
): number => {
  if (productType === CampaignProduct.CASINO) {
    return getProgress(bonus.casinoWagering, bonus.requiredCasinoWagering);
  }

  if (productType === CampaignProduct.SPORTSBOOK) {
    return getProgress(bonus.sbWagering, bonus.requiredSbWagering);
  }

  return Math.max(
    getProgress(bonus.casinoWagering, bonus.requiredCasinoWagering),
    getProgress(bonus.sbWagering, bonus.requiredSbWagering)
  );
};
